module.exports = __webpack_public_path__ + "static/media/ApiHijau.6ab46c33.svg";